import { render, staticRenderFns } from "./MailV2Editor.vue?vue&type=template&id=37f77a67&"
import script from "./MailV2Editor.vue?vue&type=script&lang=js&"
export * from "./MailV2Editor.vue?vue&type=script&lang=js&"
import style0 from "./MailV2Editor.vue?vue&type=style&index=0&id=37f77a67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports